import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { useStoreState } from 'easy-peasy';
import { useMutation } from '@apollo/react-hooks';
import { isNull } from 'lodash';
import { toast } from 'react-toastify';
import { Field, Label } from 'rbx';

import client from '../../../utils/apolloClient';
import Toggle from '../../MenuManagement/Menu/Designer/Toggle';

const searchPlacesQuery = gql`
  query searchPlacesQuery($input: SearchInput) {
    search_places(input: $input) {
      place_listing {
        place_id
        restaurant_live_status
      }
    }
  }
`;

const updatePlaceMutation = gql`
  mutation updatePlace($input: PlaceInput) {
    update_place(input: $input) {
      place_id
      name
      error {
        code
        description
      }
    }
  }
`;

const RestaurantLiveStatus = ({ placeId }) => {
  const { userId } = useStoreState(state => state.auth);
  const [placeData, setPlaceData] = useState(null);

  const [updatePlace, { loading: updatePlaceLoading }] = useMutation(
    updatePlaceMutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ update_place }) => {
        if (!isNull(update_place.error)) {
          update_place.error.map(item => toast.error(item.description));
        } else {
          toast.success('Place updated successfully');
        }
      },
    },
  );

  useEffect(() => {
    if (placeId) {
      client.clientPrivate
        .query({
          query: searchPlacesQuery,
          variables: {
            input: {
              user_id: userId,
              filter: { place_filter: { place_id: [placeId] } },
            },
          },
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          if (data?.search_places?.place_listing?.[0]) {
            const place = data.search_places.place_listing[0];
            setPlaceData(place);
          }
        });
    }
  }, [placeId]);

  const onToggle = async value => {
    if (placeId) {
      await updatePlace({
        variables: {
          input: {
            user_id: userId,
            place_id: placeId,
            restaurant_live_status: value,
          },
        },
      });
    }
  };

  if (!placeData) {
    return null;
  }

  return (
    <div>
      <>
        <Field>
          <Label>
            Publish to CDN{' '}
            <span style={{ color: '#00AEEF' }}>
              {updatePlaceLoading ? 'updating...' : ''}
            </span>
          </Label>
          <Toggle
            checked={!!placeData.restaurant_live_status}
            onToggle={async value => {
              onToggle(value);
            }}
            disabled={updatePlaceLoading}
          />
        </Field>
        <br />
      </>
    </div>
  );
};

export default RestaurantLiveStatus;
